export default __webpack_public_path__ + "static/media/111.ca8bd2b6.jpg";